const MODAL_ROOT = "link-modal-root";
const ATTRIBUTES_NEW_TAB = "link-modal-attributes-new-tab";
const ATTRIBUTES_NOFOLLOW = "link-modal-attributes-nofollow";
const ATTRIBUTES_NOREFERRER = "link-modal-attributes-noreferrer";
const ATTRIBUTES_SPONSORED = "link-modal-attributes-sponsored";
const CANCEL_BUTTON = "link-modal-cancel-button";
const SAVE_BUTTON = "link-modal-save-button";
const UNLINK_BUTTON = "link-modal-unlink-button";
const LINK_TYPE = "link-modal-link-type";
const SECTION_EMPTY_STATE = "link-modal-section-empty-state";
const SECTION_SELECT = "link-modal-section-select";
const SECTION_MULTISELECT = "link-modal-section-multiselect";
const SECTION_TYPE_SELECT = "link-modal-section-type-select";
const SITE_PAGES_EMPTY_STATE = "link-modal-site-pages-empty-state";
const SITE_PAGES_PAGE_SELECT = "link-modal-site-pages-page-select";
const URL_INPUT = "link-modal-url-input";
export {
  ATTRIBUTES_NEW_TAB,
  ATTRIBUTES_NOFOLLOW,
  ATTRIBUTES_NOREFERRER,
  ATTRIBUTES_SPONSORED,
  CANCEL_BUTTON,
  LINK_TYPE,
  MODAL_ROOT,
  SAVE_BUTTON,
  SECTION_EMPTY_STATE,
  SECTION_MULTISELECT,
  SECTION_SELECT,
  SECTION_TYPE_SELECT,
  SITE_PAGES_EMPTY_STATE,
  SITE_PAGES_PAGE_SELECT,
  UNLINK_BUTTON,
  URL_INPUT
};
//# sourceMappingURL=data-hooks.js.map
